import { render, staticRenderFns } from "./EventFeatures.vue?vue&type=template&id=421fb35f&scoped=true&"
import script from "./EventFeatures.vue?vue&type=script&lang=js&"
export * from "./EventFeatures.vue?vue&type=script&lang=js&"
import style0 from "./EventFeatures.vue?vue&type=style&index=0&id=421fb35f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421fb35f",
  null
  
)

export default component.exports